import React, { Component, ReactNode } from 'react';

import { FullHeightWrapper, SiteSection } from './SiteWrapperStyled';
import { AlbumLayouts, AlbumThemes } from '../../types';
import { VIMEO_BLUE } from '../../utils/constants';

interface Props {
  theme?: AlbumThemes;
  color?: string;
  hideNav?: boolean;
  layout?: AlbumLayouts;
  children: ReactNode;
  webBrandColor?: boolean;
}

export default class SiteWrapper extends Component<Props, {}> {
  public static defaultProps = {
    theme: 'standard',
    color: VIMEO_BLUE,
    layout: 'player',
    hideNav: false,
  };

  componentDidMount() {
    // Remove inital page load class
    document.body.classList.remove('is--loading');
  }

  public render() {
    const { theme, layout, children } = this.props;

    return (
      <FullHeightWrapper theme={theme}>
        <SiteSection theme={theme} layout={layout}>
          {children}
        </SiteSection>
      </FullHeightWrapper>
    );
  }
}
